<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Feedmill"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedFeedmills"
      :columns="columns"
      :total-rows="totalFeedmills"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import axios from 'axios';
import BaseTable from '@/components/BaseTable';

export default {
  name: 'FeedmillTable',
  components: {
    BaseTable
  },
  data() {
    return {
      feedmills: [],
      totalFeedmills: 0,
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'city', align: 'left', label: 'City', field: 'city', sortable: true },
        { name: 'state', align: 'left', label: 'State', field: 'state', sortable: true },
        { name: 'contact_person', align: 'left', label: 'Contact Person', field: 'contact_person', sortable: true },
        { name: 'rate', align: 'left', label: 'Rate', field: 'rate', sortable: true },
        { name: 'mile_rate', align: 'left', label: 'Mile Rate', field: 'mile_rate', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedFeedmills() {
      return this.feedmills.map(feedmill => ({
        ...feedmill,
        // Format dates if you want them pretty
        add_date: new Date(feedmill.add_date).toLocaleDateString(),
        edit_date: new Date(feedmill.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchFeedmills();
  },
  methods: {
    fetchFeedmills() {
      axios
        .get('/api/v1/feedmill/feedmills/')
        .then(response => {
          this.feedmills = response.data;
          this.totalFeedmills = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching feedmills:', error);
        });
    },
    onAdd() {
      // Navigate to the feedmill add page.
      // Adjust the route path to match how your app is structured:
      this.$router.push('/feedmill/add');
    },
    getEditUrl(row) {
      // Construct the route for editing this feedmill:
      return `/feedmill/edit/${row.id}/`;
    }
  },
  watch: {
    feedmills() {
      // Force table re-render if the feedmills array changes
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the FeedmillTable here */
</style>
